// extracted by mini-css-extract-plugin
export default {"wrapper":"undoRedoButtons__wrapper__Qc4DN"};